
import React, { useEffect, useState } from 'react'
import { Grid, Menu, Button, Dropdown, Icon, Ref, Sticky, Container } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import LogoIcon from "../../../../../assets/icons/Logo"
import { useDispatch, useSelector } from "react-redux";
import { ChangeActiveTab, SetShowSearchBox } from "../../../../../redux/actions/mainActions"
import SearchBox from '../../../components/SearchBox/SearchBox';
import "./NavigationBar.css"

const NavigationBar = ({ }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const fixed = useSelector((state) => state.main.fixed)
    const showSearchBox = useSelector((state) => state.main.showSearchBox)
    const [activeItem, setActiveItem] = useState('placesToStay')

    const handleItemClick = (e, name) => {
        setActiveItem(name)
        dispatch(ChangeActiveTab(name))
    }

    const searchHandler = () => {
        dispatch(SetShowSearchBox(true))
    }
    const handleScroll = () => {
        dispatch(SetShowSearchBox(false))
    }

    
    return <Menu fixed={fixed ? 'top' : null}
        secondary={true}
        className={fixed ? 'NavBar-lay1 bg-white  p-0 m-0 justify-content-center' : 'NavBar-lay1 position-absolute w-100 p-0 m-0 justify-content-center'}
    >
        <Container>
            <Grid unstackable className="w-100 m-0">
                <Grid.Row className="p-1">
                    <Menu.Item className='w-100'>
                        <Button size='huge' onClick={() => searchHandler()} className="rounded-50 bg-white w-100" basic={fixed} >
                            <Icon name='search' className="m-1-r m-1-l text-pink" />

                            {t("home:StartYourSearch")}

                        </Button>
                    </Menu.Item>
                </Grid.Row>
                <Grid.Row className="p-0">
                    <Grid.Column>
                        <SearchBox />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    </Menu>
}
export default NavigationBar